module.exports = __webpack_public_path__ + "images/review_stars_56d3993f62b2e30a741d05165a19de82.png";